import { buildAppealDetailSheet, toRows } from "./principle1DetailHelpers";

export const SHEET_NAME = "Appeal or revision case";

export function buildAppealOrRevisionCaseSheet(workbook, sectionC) {
  const essential = sectionC?.principle1?.essentialIndicators || {};
  return buildAppealDetailSheet(
    workbook,
    SHEET_NAME,
    "Details Of The Appeal Or Revision Preferred In Cases Where Monetary Or Non Monetary Action Has Been Appealed",
    toRows(essential?.appealDetails)
  );
}
